import React from "react";
import {
  FaWindows,
  FaDownload,
  FaShieldAlt,
  FaBolt,
  FaBoxes,
  FaSyncAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export const DowloadDesktopApp = () => {
  return (
    <div className="download-page">
      <div className="container">
        <div className="download-card">
          <div className="download-card-left">
            <div className="card-header">
              <div className="desktop-icon">
                <FaWindows />
              </div>

              <h2>Go Mak Desktop</h2>
              <p>Official Wholesaler Application</p>
            </div>

            <div className="divider"></div>

            <div className="features">
              <div className="feature">
                <FaBolt className="icon" />
                <span>Faster Performance</span>
              </div>

              <div className="feature">
                <FaShieldAlt className="icon" />
                <span>Secure Authentication</span>
              </div>

              {/* <div className="feature">
            <FaBoxes className="icon" />
            <span>Inventory Management</span>
          </div>

          <div className="feature">
            <FaSyncAlt className="icon" />
            <span>Automatic Updates</span>
          </div> */}
            </div>
            <div className="divider"></div>

            {/* <div className="info-grid">

          <div>
            <label>Version</label>
            <p>v2.1.0</p>
          </div>

          <div>
            <label>Size</label>
            <p>82 MB</p>
          </div>

          <div>
            <label>Supported OS</label>
            <p>Windows 10 / 11 (64-bit)</p>
          </div>

          <div>
            <label>Release Date</label>
            <p>13 July 2026</p>
          </div>

        </div> */}

            <div className="desktop-btn-container">
              <a
                // href="/App_Downloads/wholesaler_desktop_uat.zip"
                href={process.env.REACT_APP_WHOLESALER_DESKTOP_APP_URL}
                download
                className="desktop-download-btn"
              >
                Download for Windows
              </a>

              {/* <Link to="/">
              <button className="desktop-cancel-btn">Cancel</button>
            </Link> */}
              <a href="https://gomak.in/">
                <button className="desktop-cancel-btn">Cancel</button>
              </a>
            </div>
          </div>

          <div className="download-card-right">
            {/* <div className="divider"></div> */}

            <div className="installation">
              <h3>Installation Guide</h3>

              <div className="step">
                <span>1</span>
                <p>
                  Click <strong>Download for Windows</strong>.
                </p>
              </div>

              {/* <div className="step">
              <span>2</span>
              <p>
                Save <strong>wholesaler_desktop_uat.zip</strong>.
              </p>
            </div>
            <div className="step">
              <span>3</span>
              <p>
                <strong>Extract</strong> the ZIP file.
              </p>
            </div>

            <div className="step">
              <span>4</span>
              <p>
                <strong>Open</strong> the extracted folder.
              </p>
            </div> */}

              <div className="step">
                <span>2</span>
                <p>
                  Double-click on <strong>wholesaler.exe.</strong>
                </p>
              </div>

              <div className="step">
                <span>3</span>
                <p>Login using your existing wholesaler credentials.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
